var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRsr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2000",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.95 40.474)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1016,1959.5c550.8,0,1000-449.2,1000-1000c0-550.7-449.2-1000-1000-1000c-550.7,0-1000,449.3-1000,1000 C15.9,1510.3,465.2,1959.5,1016,1959.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M759.5,441.2h144c5.5,0,9.9,4.5,9.9,10v210.4c0,5.6,4.5,10,10,10h184.9c5.5,0,10-4.4,10-10V451.2 c0-5.5,4.4-10,10-10h143.9c5.5,0,10,4.5,10,10v210.4c0,5.6,4.4,10,10,10h176c5.6,0,10,4.5,10,10v143.6c0,5.6-4.4,10-10,10h-176 c-5.6,0-10,4.5-10,10v223.5c0,5.5,4.4,10,10,10h176c5.6,0,10,4.4,10,10v143.6c0,5.5-4.4,10-10,10h-176c-5.6,0-10,4.5-10,10v210.4 c0,5.5-4.5,10-10,10h-143.9c-5.6,0-10-4.5-10-10v-210.4c0-5.6-4.5-10-10-10H923.5c-5.5,0-10,4.5-10,10v210.4c0,5.5-4.4,10-9.9,10 h-144c-5.5,0-10-4.5-10-10v-210.4c0-5.6-4.4-10-10-10h-176c-5.6,0-10-4.5-10-10v-143.6c0-5.6,4.4-10,10-10h176c5.6,0,10-4.5,10-10 V845.2c0-5.5-4.4-10-10-10h-176c-5.6,0-10-4.4-10-10V681.6c0-5.5,4.4-10,10-10h176c5.6,0,10-4.4,10-10V451.2 C749.4,445.7,754,441.2,759.5,441.2L759.5,441.2z M1118.4,1068.8V845.2c0-5.5-4.5-10-10-10H923.5c-5.5,0-10,4.5-10,10v223.5 c0,5.5,4.5,10,10,10h184.9C1113.9,1078.8,1118.4,1074.2,1118.4,1068.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsr);
export default __webpack_public_path__ + "static/media/rsr.29f5c9cf68624af7c41acc9dd190b402.svg";
export { ForwardRef as ReactComponent };